import { defineElement } from '@webtides/element-js';
import BaseRetailerSearchInfoBox from '@zeg/base-light-module/frontend/components/structures/_retailer-search/retailer-search-info-box/retailer-search-info-box.class';
import style from './retailer-search-info-box.css';

class RetailerSearchInfoBox extends BaseRetailerSearchInfoBox {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }
}

defineElement('retailer-search-info-box', RetailerSearchInfoBox);
